export enum DataRequestStatusEnum {
  Idle = 'idle',
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
}

export enum AppDataEnum {
  UserBanks = 'userBanks',
  Banners = 'banners',
  LiveCasino = 'liveCasino',
  LiveCasinoCategories = 'liveCasinoCategories',
  LiveCasinoProviders = 'liveCasinoProviders',
  LiveCasinoIndirect = 'liveCasinoIndirect',
  LobbyGames = 'lobbyGames',
  TopWinning = 'topWinning',
  TopChampion = 'topChampion',
  HotMatches = 'hotMatches',
  ScheduleMatches = 'scheduleMatches',
  JackpotGame = 'jackpotGame',
  SEO = 'seo',
}

export enum AppStoreEnum {
  User = 'user',
  Jackpot = 'jackpot',
  Promotion = 'promotion',
  UserPromotion = 'userPromotion',
  MaintenanceGames = 'maintenanceGames',
  UserBettingHistory = 'userBettingHistory',
  Deposit = 'deposit',
  Bank = 'bank',
  Packages = 'packages',
  RegisterAddon = 'registerAddon',
  FavoriteGames = 'favoriteGames',
  Games = 'games',
  Modals = 'modals',
  GameToast = 'gameToast',
}

export enum AppStorageEnum {
  Storage = 'storage',
}

export enum RouterEnum {
  Home = '/',
  Login = '/login',
  Account = '/account',
  ResetPassword = '/reset-password',
  NotFound = '/404',
  Maintenance = '/maintenance'
}

export enum ResponseStatus {
  OK = 'OK',
  AUTHENTICATION_REQUIRED_ERROR = 'AUTHENTICATION_REQUIRED_ERROR',
  PASSWORD_INCORRECT = 'PASSWORD_INCORRECT',
  INVALID_PACKAGE_ID_INVOICE_ERROR = 'INVALID_PACKAGE_ID_INVOICE_ERROR',
  INSUFFICIENT_EXCHANGE_PACKAGE_ERROR = 'INSUFFICIENT_EXCHANGE_PACKAGE_ERROR',
  USER_EXISTED_ERROR = 'USER_EXISTED_ERROR',
  FULLNAME_EXISTED_ERROR = 'FULLNAME_EXISTED_ERROR',
  USER_REGISTER_MANYTIME = 'USER_REGISTER_MANYTIME',
  INVALID_PROMOTION_ERROR = 'INVALID_PROMOTION_ERROR',
  REQUIRED_USER_INFO = 'REQUIRED_USER_INFO',
  NEED_TO_ENTER_USERNAME = 'NEED_TO_ENTER_USERNAME',
  TOO_MANY_INVOICE_RUNNING = 'TOO_MANY_INVOICE_RUNNING',
  INVALID_PHONE_CARD_ERROR = 'INVALID_PHONE_CARD_ERROR',
  INVALID_WITHDRAW_AMOUNT_ERROR = 'INVALID_WITHDRAW_AMOUNT_ERROR',
  INSUFFICIENT_BALANCE_ERROR = 'ADD_INVOICE_FAIL_ERROR',
  ADD_WITHDRAW_INVOICE_FAIL_ERROR = 'ADD_WITHDRAW_INVOICE_FAIL_ERROR',
  INVALID_ACCOUNT_NAME = 'INVALID_ACCOUNT_NAME',
  CRYPTO_EXCHANGE_RATE_CHANGED_ERROR = 'CRYPTO_EXCHANGE_RATE_CHANGED_ERROR',
  EMAIL_ALREADY_EXIST = 'EMAIL_ALREADY_EXIST',
}

export enum BehaviorScrollToTop {
  SMOOTH = 'smooth',
  INSTANT = 'instant',
  AUTO = 'auto',
}

export enum SlugType {
  IFRAMES = 'IFRAMES',
  NEWS_SLUG = 'NEWS_SLUG',
  NEWS_DETAIL = 'NEWS_DETAIL',
  PROMOTION_SLUG = 'PROMOTION_SLUG',
  SIMPLE_PAGE_SLUG = 'SIMPLE_PAGE_SLUG',
  RESET_PASSWORD_SLUG = 'RESET_PASSWORD_SLUG',
}

export enum OSEnum {
  IOS = 'ios',
  ANDROID = 'android',
  WINDOWS = 'windows',
  MACOS = 'macOS',
  APPLE = 'apple',
}

export enum BrowserEnum {
  SAFARI = 'safari',
  FIREFOX = 'firefox',
  EDGE = 'edge',
  CHROME = 'chrome',
  SAMSUNG = 'samsung',
}

export enum DeviceEnum {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export enum FavoriteGamesAction {
  ADD = 'add',
  DELETE = 'delete',
}
